import Axios, { AxiosError, AxiosResponse, Method, ResponseType } from "axios";

export const authorizedAxios = <T>(
    requestType: Method,
    requestUrl: string,
    requestParams?: {},
    data?: {},
    responseType?: ResponseType
): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
        getBearerToken()
            .then((bearerToken: string) => {
                Axios({
                    method: requestType,
                    url: requestUrl,
                    data: data,
                    headers: { Authorization: "Bearer " + bearerToken },
                    params: requestParams,
                    responseType: responseType || "json",
                })
                    .then((response: AxiosResponse<T>) => {
                        resolve(response.data);
                    })
                    .catch((requestError: AxiosError) => {
                        if (requestError.response?.status === 401) {
                            (window as any).scout.actions.showSessionExpiredAlert();
                        }
                        reject(requestError);
                    });
            })
            .catch((tokenError: AxiosError) => {
                reject(tokenError);
            });
    });
};

export const getBearerToken = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        Axios.get<string>(`/Token/AccessToken`)
            .then(
                (response: AxiosResponse) => {
                    resolve(response.data.data);
                },
                (error: AxiosError) => {
                    if (error.response?.status === 401) {
                        (window as any).scout.actions.showSessionExpiredAlert();
                    }
                    reject(error.message);
                }
            )
            .catch((error: AxiosError) => {
                reject(error.message);
            });
    });
};
